import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsTagsBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Tags</div>
          <div className="text">
            Posts can be assigned multiple tags. Each tag is for a specific board,
            not&nbsp;company-wide.
          </div>
          <div className="text">
            Our API allows you to create, list, and retrieve tags. You can also tag and&nbsp;un-tag
            posts.
          </div>
        </div>
        <div />
      </APIDocsBlock>
    );
  }
}
